import { FC } from 'react'
import { MiFooter } from '../../components/mi/Footer'
import { MiNavbar } from '../../components/mi/Navbar'
import { SignupSection } from '../../components/mi/account/signup'
import { StyleBody } from '../../styles/mi'

export const Signup: FC = () => {
  return (
    <StyleBody>
      <MiNavbar />
      <SignupSection></SignupSection>
      <MiFooter />
    </StyleBody>
  )
}
